import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList } from "vue"

const _hoisted_1 = {
  class: "col-12 overview-item listed-search-article",
  "data-mm-load-item": ""
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "link card-link" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = { class: "card-title-heading" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 col-md-9" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "col-12 col-md-4" }
const _hoisted_13 = {
  key: 0,
  class: "breadcrumb mb-0 py-0"
}
const _hoisted_14 = {
  key: 1,
  class: "breadcrumb mb-0 py-0"
}
const _hoisted_15 = { class: "col-12 col-md-4" }
const _hoisted_16 = { class: "breadcrumb mb-0 py-0 text-md-center w-100 d-md-block" }
const _hoisted_17 = { class: "col-12 col-md-4 text-right py-0" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "sr-only" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, [
                      _createTextVNode(_toDisplayString((_ctx.item && _ctx.item['course_title_t'] && _ctx.item['course_title_t'][0]) || "Kurs") + " ", 1),
                      (_ctx.item && _ctx.item['course_code_t'] && _ctx.item['course_code_t'][0])
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("(" + _toDisplayString(_ctx.item['course_code_t'][0]) + ")", 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              (_ctx.highlight)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    innerHTML: _ctx.sanitizeHtml(`… ${_ctx.highlight} …`),
                    class: "card-text"
                  }, null, 8, _hoisted_11))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.item && _ctx.item['course_training_id_ss'] || []), (itemId, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row mt-2",
          key: index
        }, [
          _createElementVNode("div", _hoisted_12, [
            (_ctx.item && _ctx.item['course_training_end_dts'] && _ctx.item['course_training_end_dts'][index] && _ctx.isOpenEndDate(_ctx.item['course_training_end_dts'][index]))
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Termin/e: Nach Vereinbarung "))
              : (_openBlock(), _createElementBlock("p", _hoisted_14, [
                  _createTextVNode(" Termin/e: " + _toDisplayString(_ctx.formatDate(_ctx.item && _ctx.item['course_training_start_dts'] && _ctx.item['course_training_start_dts'][index] || '')), 1),
                  (_ctx.item && _ctx.item['course_training_end_dts'] && _ctx.item['course_training_end_dts'][index])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" - " + _toDisplayString(_ctx.formatDate(_ctx.item['course_training_end_dts'][index])), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, [
              (_ctx.item && _ctx.item['course_formtype_t'] && _ctx.item['course_formtype_t'][0])
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.getFormText(_ctx.item['course_formtype_t'][0])), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("a", {
              href: _ctx.sanitizeUrl(_ctx.url(index)),
              class: "p-0 w-100 ml-auto breadcrumb no-underline text-primary d-flex align-items-center justify-content-end",
              target: "_self"
            }, [
              _cache[0] || (_cache[0] = _createElementVNode("span", {
                class: "icon icon-navigation_pfeil_rechts",
                "aria-hidden": "true"
              }, null, -1)),
              _cache[1] || (_cache[1] = _createTextVNode(" Details anzeigen ", -1)),
              _createElementVNode("span", _hoisted_19, [
                _createTextVNode("zum Seminar " + _toDisplayString((_ctx.item && _ctx.item['course_title_t'] && _ctx.item['course_title_t'][0]) || "Kurs") + " ", 1),
                (_ctx.item && _ctx.item['course_training_end_dts'] && _ctx.item['course_training_end_dts'][index] && _ctx.isOpenEndDate(_ctx.item['course_training_end_dts'][index]))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, " (Termin nach Vereinbarung) "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createTextVNode(" zum Termin " + _toDisplayString(_ctx.formatDate(_ctx.item && _ctx.item['course_training_start_dts'] && _ctx.item['course_training_start_dts'][index] || '')), 1),
                      (_ctx.item && _ctx.item['course_training_end_dts'] && _ctx.item['course_training_end_dts'][index])
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" - " + _toDisplayString(_ctx.formatDate(_ctx.item['course_training_end_dts'][index])), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
              ])
            ], 8, _hoisted_18)
          ])
        ]))
      }), 128))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "badge",
      "aria-hidden": "true"
    }, null, -1))
  ]))
}